import { render, staticRenderFns } from "./genomics-protein-add.vue?vue&type=template&id=0dc5354a&scoped=true"
import script from "./genomics-protein-add.vue?vue&type=script&lang=js"
export * from "./genomics-protein-add.vue?vue&type=script&lang=js"
import style0 from "./genomics-protein-add.vue?vue&type=style&index=0&id=0dc5354a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5354a",
  null
  
)

export default component.exports